import OpendataTag from "@/api/models/opendata-tag.model";
import OpendataGroup from "@/api/models/opendata-group.model";

class OpendataDataset {
  id: number | null = null;
  gid: number | null = null;
  dataType: string | null = null;
  title: string | null = null;
  name: string | null = null;
  ownerOrg: string | null = null;
  allowHarvest: string | null = null;
  maintainer: string | null = null;
  maintainerEmail: string | null = null;
  note: string | null = null;
  objective: string | null = null;
  objectiveOther: string | null = null;
  updateFrequencyUnit: string | null = null;
  updateFrequencyUnitOther: string | null = null;
  updateFrequencyInterval: number | null = null;
  geoCoverage: string | null = null;
  geoCoverageOther: string | null = null;
  dataSource: string | null = null;
  dataFormat: string | null = null;
  dataFormatOther: string | null = null;
  dataCategory: string | null = null;
  licenseId: string | null = null;
  licenseIdOther: string | null = null;
  accessibleCondition: string | null = null;
  url: string | null = null;
  dataLanguage: string | null = null;
  dataLanguageOther: string | null = null;
  lastUpdateDate: string | null = null;
  dataReleaseCalendar: string | null = null;
  firstYearOfData: string | null = null;
  lastYearOfData: string | null = null;
  disaggregate: string | null = null;
  disaggregateOther: string | null = null;
  unitOfMeasure: string | null = null;
  unitOfMultiplier: string | null = null;
  unitOfMultiplierOther: string | null = null;
  calculationMethod: string | null = null;
  officialStatistics: string | null = null;
  dataSupport: string | null = null;
  dataSupportOther: string | null = null;
  dataCollect: string | null = null;
  dataCollectOther: string | null = null;
  createdDate: string | null = null;
  highValueDataset: string | null = null;
  referenceData: string | null = null;
  geographicDataSet: string | null = null;
  equivalentScale: string | null = null;
  equivalentScaleOther: string | null = null;
  westBoundLongitude: string | null = null;
  eastBoundLongitude: string | null = null;
  northBoundLongitude: string | null = null;
  southBoundLongitude: string | null = null;
  positionalAccuracy: string | null = null;
  referencePeriod: string | null = null;
  dataReleaseDate: string | null = null;
  postmanCollection: string | null = null;
  accessiblePolicy: string | null = null;
  metadata: string | null = null;
  usageUrl: string | null = null;
  usageMethod: string | null = null;
  usageRequest: string | null = null;
  usageResponse: string | null = null;
  dataStandard: string | null = null;
  total: number | null = null;
  totalViews: number | null = null;
  otagDtos: Array<OpendataTag> = new Array<OpendataTag>();
  ogroupDto: Array<OpendataGroup> = new Array<OpendataGroup>();
}

export default OpendataDataset;
